import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { UiBlocker } from '@bingads-webui-fluent-component/ui-blocker';
import { useWizardService, getWizardData, } from '@bingads-webui-fluent-component/wizard';

export const ProcessingBlocker = ({ children }) => {
  const i18n = useContext(I18nContext);
  const { state } = useWizardService();
  const { isProcessing, isSavingCompanyPage } = getWizardData(state);
  const loadingText = isSavingCompanyPage ? i18n.getString(_TL_('Please hang on, we are creating your ad account and setting up the permissions ...')) : i18n.getString(_TL_('Processing...'));
  const labelPosition = isSavingCompanyPage ? 'below' : 'after';

  return (
    <UiBlocker blocking={isProcessing || isSavingCompanyPage} loadingText={loadingText} labelPosition={labelPosition}>
      {children}
    </UiBlocker>
  );
};
ProcessingBlocker.propTypes = {
  children: PropTypes.node.isRequired,
};
